module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/sections--financial-performance.9430be6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/sections--financial-performance.pdf
// module id = n3kk
// module chunks = 10